import { Box, Button, Grid2, Paper, TextField, Typography } from "@mui/material";
import Wrapper from "../components/Wrapper";
import PageLoader from "../components/PageLoader";
import { useCallback, useEffect, useState } from "react";
import MainQuestionnaireOption from "../components/MainQuestionnaireOption";
import { enqueueSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import { addQuestion, getQuestion, updateQuestion } from "../services/main-questionnaire";

const BLANK_OPTION = {
  title: '',
  option_order: '',
  modalities: []
}

const MainQuestionnaireForm = () => {

  const [is_loading, set_is_loading] = useState(false);
  const [title, set_title] = useState('');
  const [next_page_question, set_next_page_question] = useState('');
  const [question_key, set_question_key] = useState('');
  const [question_order, set_question_order] = useState('');
  const [options, set_options] = useState([]);

  const navigate = useNavigate();

  const params = useParams();
  const id = params.id;

  const handleAddOption = () => {
    set_options([...options, BLANK_OPTION])
  }

  const handleDeleteOption = (index) => {
    const _options = [...options];
    _options.splice(index, 1);
    set_options(_options)
  }

  const handleOptionChange = (index, key, value) => {
    const _options = [...options];
    const selected_option = {..._options[index]};
    selected_option[key] = value;
    _options[index] = selected_option;
    set_options(_options);
  }

  const isDataFilled = () => {
    let count = 0;

    if(!Boolean(title)){
      count++;
    }
    if(!Boolean(next_page_question)){
      count++;
    }
    if(!Boolean(question_key)){
      count++;
    }
    if(!Boolean(question_order)){
      count++;
    }
    if(!Boolean(options.length)){
      count++
    }

    options.forEach((option) => {
      if(!Boolean(option.title)){
        count++
      }
      if(!Boolean(option.option_order)){
        count++
      }
      if(!Boolean(option.modalities.length)){
        count++
      }

      option.modalities.forEach((modality) => {
        if(!Boolean(modality.modality)){
          count++
        }
        if(!Boolean(modality.healers.length)){
          count++
        }
      })
    })

    return count === 0;
  }

  const handleSave = async () => {
    if(isDataFilled()){

      const data = {
        title : title,
        question_key : question_key,
        next_page_question : next_page_question,
        question_order : question_order,
        options : options
      }

      let apiFunction;

      if(id){
        apiFunction = updateQuestion({
          id : id,
          data : data
        })
      }else{
        apiFunction = addQuestion({
          data : data
        })
      }
      const { error } = await apiFunction;
      
      if(error){
        enqueueSnackbar('Error while saving question', {
          variant : 'error'
        })
      }else{
        enqueueSnackbar('Question saved successfully !' , {
          variant : 'success'
        })

        if(!Boolean(id)){
          navigate('/main-questionnaire')
        }
      }
    }else{
      enqueueSnackbar('Please fill all data', {
        variant : 'warning'
      })
    }
  }

  const getQuestionDetails = useCallback(async () => {
    set_is_loading(true);
    const { data } = await getQuestion({ id : id });
    set_is_loading(false);
    if(data){
      set_title(data.data.title)
      set_question_key(data.data.question_key)
      set_next_page_question(data.data.next_page_question)
      set_question_order(data.data.question_order)
      set_options(data.data.options)
    }
  }, [id])

  useEffect(() => {
    if(id){
      getQuestionDetails();
    }
  }, [id, getQuestionDetails])

  return (
    <Wrapper>
      <PageLoader
        show={is_loading}
      />
      <Paper
        sx={{
          padding: '20px'
        }}
      >
        <Grid2
          container
          spacing={3}
        >
          <Grid2 size={4}>
            <TextField
              multiline
              fullWidth
              label="Title"
              value={title}
              onChange={(e) => set_title(e.target.value)}
              rows={3}
            />
          </Grid2>
          <Grid2 size={4}>
            <TextField
              multiline
              fullWidth
              label="Next Page Question"
              value={next_page_question}
              onChange={(e) => set_next_page_question(e.target.value)}
              rows={3}
            />
          </Grid2>
          <Grid2 size={2}>
            <TextField
              fullWidth
              label="Question Key"
              value={question_key}
              onChange={(e) => set_question_key(e.target.value.toUpperCase())}
            />
          </Grid2>
          <Grid2 size={2}>
            <TextField
              fullWidth
              label="Question Order"
              value={question_order}
              onChange={(e) => set_question_order(e.target.value)}
            />
          </Grid2>
        </Grid2>
      </Paper>

      <Paper
        sx={{
          padding: '10px',
          marginTop: '24px'
        }}
      >
        <Box
          display='flex'
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography
            variant='h6'
          >
            Options
          </Typography>
          <Button
            variant="contained"
            size="small"
            onClick={handleAddOption}
          >
            Add New Option
          </Button>
        </Box>
      </Paper>

      <Grid2
        container
        spacing={3}
        marginTop='24px'
      >
        {
          options.map((option, index) => {
            return(
              <Grid2
                size={4}
                key={`OPTION-${index}`}
              >
                <MainQuestionnaireOption
                  option = {option}
                  handleOptionChange = {handleOptionChange}
                  handleDeleteOption = {handleDeleteOption}
                  index = {index}
                />
              </Grid2>
            )
          }, [])
        }
      </Grid2>
      
       <Paper
        sx={{
          padding: '10px',
          display : 'flex',
          justifyContent : 'flex-end',
          marginTop : '24px'
        }}
      >
        <Button
          variant="contained"
          onClick={handleSave}
        >
          Save
        </Button>
      </Paper>
    </Wrapper>
  )
}

export default MainQuestionnaireForm;